import { TemplateType } from '@tokeet-frontend/templates'

export interface AutomationEventTemplateSample {
  name: string
  subject: string
  description: string
  body: string
  type: TemplateType.Email | TemplateType.Payload | TemplateType.PushNotification
}

export const deviceBatteryLowTemplateSample: AutomationEventTemplateSample = {
  name: $localize`Battery is low`,
  subject: $localize`Battery is low for` + ' *|DEVICE:NAME|*',
  description: '',
  body:
    $localize`Hi,` +
    `<br><br> ` +
    $localize`Smart Device` +
    ' *|DEVICE:NAME|* ' +
    $localize`battery is low. Please replace batteries.`,
  type: TemplateType.Email,
}
export const deviceCodeFirstUsedTemplateSample: AutomationEventTemplateSample = {
  name: $localize`Device code first used`,
  subject: $localize`Device code first used for` + ' *|DEVICE:NAME|*',
  description: '',
  body:
    $localize`Hi,` +
    `<br><br> ` +
    $localize`Guest` +
    ' *|GUEST:NAME|* ' +
    $localize`has used this code first time for Rental` +
    ' *|RENTAL:NAME|* ' +
    $localize`for this booking` +
    ' *|INQUIRY:ARRIVE|* ' +
    $localize`to` +
    ' *|INQUIRY:DEPART|*.',
  type: TemplateType.Email,
}

export const deviceIssuesRequireAttentionTemplateSample: AutomationEventTemplateSample = {
  name: $localize`Device issues require attention`,
  subject: $localize`Device issues for` + ' *|DEVICE:NAME|*',
  description: '',
  body:
    $localize`Hi,` +
    `<br><br> ` +
    $localize`Something is wrong with device` +
    ' *|DEVICE:NAME|* ' +
    $localize`for` +
    ' *|RENTAL:NAME|*. ' +
    $localize`Please check the device configuration.`,
  type: TemplateType.Email,
}

export const bookingConfirmedNotifyEmailTemplateSample: AutomationEventTemplateSample = {
  name: $localize`Booking Confirmation Message to Guest`,
  subject: $localize`Thanks for booking` + ' *|RENTAL:NAME|*',
  description: '',
  body:
    $localize`Hi` +
    ' *|GUEST:NAME|*,<br><br> ' +
    $localize`We are happy that you have decided to book our place. We look forward to having you as our guest, and will do whatever we can to make your stay enjoyable! We will be sending you some pre-arrival information including check in and wifi details a few days before your scheduled arrival. If you have any questions before then, just let us know. Your booking details are below for your reference.` +
    '<br><br>' +
    $localize`Property:` +
    ' *|RENTAL:NAME|*<br> ' +
    $localize`Adults:` +
    ' *|INQUIRY:ADULTS|*<br> ' +
    $localize`Children:` +
    ' *|INQUIRY:CHILDREN|*<br> ' +
    $localize`Arrival:` +
    ' *|INQUIRY:ARRIVE|*<br> ' +
    $localize`Departure:` +
    ' *|INQUIRY:DEPART|*<br> ' +
    $localize`Total:` +
    ' *|INQUIRY:COST|*',
  type: TemplateType.Email,
}

export const bookingCanceledNotifyEmailTemplateSample: AutomationEventTemplateSample = {
  name: $localize`Booking Cancellation Message to Guest`,
  subject: $localize`We are sorry to see you cancel your stay at ` + '*|RENTAL:NAME|*',
  description: '',
  body:
    $localize`Hi` +
    ' *|GUEST:NAME|*,' +
    `<br><br> ` +
    $localize`We are disappointed to see that you have cancelled your stay with us at` +
    ' *|RENTAL:NAME|* ' +
    $localize`from` +
    ' *|INQUIRY:ARRIVE|* ' +
    $localize`to` +
    ' *|INQUIRY:DEPART|*. ' +
    $localize`If there is anything we can do to assist you with getting rebooked, please let us know. We would love to have you as a guest, and we wish you the best of luck in your journey.` +
    `<br><br> ` +
    $localize`Thank you for your interest.` +
    `<br>`,
  type: TemplateType.Email,
}

export const incidentCreatedAITemplateSample: AutomationEventTemplateSample = {
  name: $localize`AI Created an Incident`,
  subject: $localize`AI Created an Incident`,
  description: '',
  body: $localize`
      Hi Team,

      An incident has been reported regarding the guest's stay at *|RENTAL:NAME|*. Please review the details and take the necessary actions.

      Incident Details:
      Description: *|INCIDENT:DESCRIPTION|*
      `,
  type: TemplateType.Email,
}
